import { render } from "./TileShape.vue?vue&type=template&id=2d5e06a9&scoped=true"
import script from "./TileShape.vue?vue&type=script&lang=js"
export * from "./TileShape.vue?vue&type=script&lang=js"

import "./TileShape.vue?vue&type=style&index=0&id=2d5e06a9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5e06a9"]])

export default __exports__